const getLocalId = (): string => {
	return Math.random().toString();
};

export default getLocalId;
